import { createReducer, on } from '@ngrx/store';
import * as NavActions from '../actions/nav.action';
import { ChatStatus } from 'src/app/core/models/chatStatus.model';

export interface NavState {
  menuOpen: boolean;
  filtersOpen: boolean;
  theme: string;
  chatStatus: ChatStatus;
  transparent: boolean;
  cartPaneOpen: boolean;
  searchOpen: boolean;
  defaultTheme?: string;
}

export const initialState: NavState = {
  menuOpen: false,
  theme: 'palette-gray',
  chatStatus: 'default',
  transparent: false,
  filtersOpen: false,
  cartPaneOpen: false,
  searchOpen: false,
};

export const NavReducer = createReducer(
  initialState,
  on(NavActions.OpenMenu, state => {
    return {
      ...state,
      menuOpen: true,
    };
  }),
  on(NavActions.CloseMenu, state => {
    return {
      ...state,
      menuOpen: false,
    };
  }),
  on(NavActions.OpenSearch, state => {
    return {
      ...state,
      searchOpen: true,
    };
  }),
  on(NavActions.CloseSearch, state => {
    return {
      ...state,
      searchOpen: false,
    };
  }),
  on(NavActions.ToggleMenu, state => {
    return {
      ...state,
      menuOpen: !state.menuOpen,
    };
  }),
  on(NavActions.ResetTheme, state => {
    return {
      ...state,
      theme: state.defaultTheme || initialState.theme,
    };
  }),
  on(NavActions.SetTheme, (state, { theme }) => {
    return {
      ...state,
      theme,
    };
  }),
  on(NavActions.SetDefaultTheme, (state, { theme }) => {
    if (!theme) {
      return state;
    }

    return {
      ...state,
      defaultTheme: theme,
      theme,
    };
  }),
  on(NavActions.SetChatStatus, (state, { status }) => {
    return {
      ...state,
      chatStatus: status,
    };
  }),
  on(NavActions.SetNavTransparency, (state, { transparent }) => {
    return {
      ...state,
      transparent,
    };
  }),
  on(NavActions.OpenFilters, state => {
    return {
      ...state,
      filtersOpen: true,
    };
  }),
  on(NavActions.CloseFilters, state => {
    return {
      ...state,
      filtersOpen: false,
    };
  }),

  on(NavActions.OpenCart, state => {
    return {
      ...state,
      cartPaneOpen: true,
    };
  }),
  on(NavActions.CloseCart, state => {
    return {
      ...state,
      cartPaneOpen: false,
    };
  }),
  on(NavActions.ToggleCart, state => {
    return {
      ...state,
      cartPaneOpen: !state.cartPaneOpen,
    };
  })
);

export const getMenuOpen = (state: NavState) => state.menuOpen;
export const getFiltersOpen = (state: NavState) => state.filtersOpen;
export const getTheme = (state: NavState) => state.theme;
